import { StyleSheet } from "react-native";
import { WeekCalendar, type WeekCalendarProps } from "react-native-calendars";
import { WEEK_DAY_ITEM_HEIGHT, WeekDayItem } from "~/components/layout/calendar/WeekDayItem";
import { useJournal } from "~/providers/JournalProvider";
import { useTheme } from "~/providers/ThemeProvider";

const WEEK_CALENDAR_HEADER_HEIGHT = 27;
const WEEK_CALENDAR_HEIGHT = WEEK_CALENDAR_HEADER_HEIGHT + WEEK_DAY_ITEM_HEIGHT;

export const WeekDayCalendar = ({ style, theme, ...calendarProps }: WeekCalendarProps) => {
    const { colours } = useTheme();
    const { marked } = useJournal();

    return (
        <WeekCalendar
            markedDates={marked}
            dayComponent={WeekDayItem}
            calendarHeight={WEEK_DAY_ITEM_HEIGHT}
            style={[styles.calendar, style]}
            theme={{
                calendarBackground: "transparent",
                textSectionTitleColor: colours.text.tertiary,
                ...theme,
            }}
            {...calendarProps}
        />
    );
};

const styles = StyleSheet.create({
    calendar: {
        maxHeight: WEEK_CALENDAR_HEIGHT,
        minHeight: WEEK_CALENDAR_HEIGHT,
    },
});
